import { useCallback, useEffect } from 'react'
import usePlacesAutocompleteService from 'react-google-autocomplete/lib/usePlacesAutocompleteService'

const useGoogleAddressAutocomplete = ({ inputValue, enabled = false }: { inputValue?: string, enabled?: boolean }) => {
  const publicKey = import.meta.graphCommerce.googleMapsApiKey;

  const { getPlacePredictions, placePredictions, placesService } = usePlacesAutocompleteService({
    apiKey: publicKey || ''
  });


  const getPredictions = useCallback(async (value) => {
    const result = await getPlacePredictions({
      input: value,
      region: 'us',
      componentRestrictions:{ country: 'us' }
    })
  }, [getPlacePredictions])

  useEffect(() => {
    getPredictions(inputValue);
  }, [inputValue])

  const getPlaceDetails = useCallback((placeId, callback) => {
    placesService.getDetails({ placeId }, (result) => {
      if (result) {
        const { address_components } = result;
        callback({
          street: address_components.find(addr => addr.types.includes('route'))?.short_name,
          house: address_components.find(addr => addr.types.includes('street_number'))?.short_name,
          postCode: address_components.find(addr => addr.types.includes('postal_code'))?.short_name,
          city: address_components.find(addr => addr.types.includes('locality') || addr.types.includes('sublocality'))?.short_name,
          regionCode: address_components.find(addr => addr.types.includes('administrative_area_level_1'))?.short_name,
          countryCode: address_components.find(addr => addr.types.includes('country'))?.short_name
        })
      }
    })
  }, [placesService])

  return {
    getPredictions,
    placePredictions,
    getPlaceDetails
  }
}
export { useGoogleAddressAutocomplete }
